module.exports = __webpack_public_path__ + "img/meibai.e0ae71a3.png";